import 'bolt/attributes/data-submittable.js';

import compose from 'fn/compose.js';
import get     from 'fn/get.js';
import events  from 'dom/events.js';
import matches from 'dom/matches.js';
import find    from 'dom/find.js';

events('dom-submitted', document)
    .filter(compose(matches('.newsletter-block'), get('target')))
    .each(function(e) {
        /* button */
        var t = find('[type="submit"]', e.target);
        /* field */
        var f = find('input[type="email"]', e.target.parentNode);
        if (f) {
            f.value = '';
            f.placeholder = 'Thanks!'
        } else if(t) {
            t.value = 'Thanks!';
        }
    });
